import { NotificationToModifyOtherTask } from '@evorait/pace-core';

export interface PaceNotificationPreviewInterface {
    identifier: {
        qmNum: string;
        maNum: string;
        frontId: string;
    };
    notificationText: string;
    getMainEquipment: {
        tidnr: {
            value: string;
        };
        equiShortDesc: {
            value: string;
        };
    };
    getContactName?: () => string;
}

export function otherTaskToPreview(otherTask: NotificationToModifyOtherTask): PaceNotificationPreviewInterface {
    return {
        identifier: {
            qmNum: otherTask.NotificationNo,
            maNum: otherTask.TaskNo,
            frontId: otherTask.FrontId,
        },
        notificationText: otherTask.ShortText,
        getMainEquipment: {
            tidnr: {
                value: otherTask.Equipment,
            },
            equiShortDesc: {
                value: otherTask.Equidescr,
            },
        },
    };
}
